import ProductCardV2 from './ProductCardV2'

export default ProductCardV2
